import { render } from "./Accordion.vue?vue&type=template&id=31981ef4"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"

import exportComponent from "/builds/lahautesociete/projects/roche/depistage-diabete/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__